// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'

import {
  Spinner,
  Warning,
  CheckboxToggle
} from '../../'

import { QUERY_EMPLOYER } from '../../../queries'

const hasAPIAccess = (api, employer) => {
  switch(api) {
    case 'sms':
      return employer.hasSmsApiAccess

    case 'payslip':
      return employer.hasPayslipApiAccess

    default:
      return false
  }
}


export const EmployerAPIAccess = ({ api, employerId, onChange }) => (
  <Query query={QUERY_EMPLOYER} variables={{ id: employerId }}>
    {({ loading, error, data, refetch }) => {
      if (loading) {
        return <Spinner size='x-small' className='slds-is-relative' />
      }

      if (error) {
        return <Warning title='Failed to fetch state'></Warning>
      }

      const apiIdentityNodeId = `${api}ApiIdentityNodeId`
      return (
        <APIAccess
          id={employerId}
          active={hasAPIAccess(api, data.employer)}
          onChange={(allowAccess) => {
            onChange(allowAccess, data.employer[apiIdentityNodeId], refetch)
          }}
        />
      )
    }}
  </Query>
)

EmployerAPIAccess.propTypes = {
  employerId: PropTypes.string.isRequired
}


class APIAccess extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
  }

  toggleAccess = () => this.props.onChange(!this.props.active)

  render() {
    return (
      <CheckboxToggle
        id={this.props.id}
        title='Activated'
        checked={this.props.active}
        onChange={this.toggleAccess}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-api-access/index.js